import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PrivateRoutes from './components/PrivateRoutes';
import PublicRoute from './components/PublicRoute';
import Dashboard from './pages/Dashboard/Dashboard';
import Errorpage from './pages/Errorpage/Errorpage';
import Workload from './pages/Workload/Workload';
import AssignOffice from './pages/AssignOffice/AssignOffice';
import AddNewOffice from './pages/AddNewOffice/AddNewOffice';
import OfficeLocations from './pages/OfficeLocations/OfficeLocations';
import OfficeAgents from './pages/OfficeAgents/OfficeAgents';
import AddMarketingExec from './pages/AddMarketingExec/AddMarketingExec';
import ViewMarketingExec from './pages/ViewMarketingExec/ViewMarketingExec';
import DoNotCallList from './pages/DoNotCallList/DoNotCallList';
import MyTasks from './pages/MyTasks/MyTasks';
// import MyTasksList from './pages/MyTasksList/MyTasksList';
import MyTasksBoard from './pages/MyTasksBoard/MyTasksBoard';
import MarketingExecDashboard from './pages/MarketingExecDashboard/MarketingExecDashboard';
import Compensation from './pages/Compensation/Compensation';
import MyTasksCalendar from './pages/MyTasksCalendar/MyTasksCalendar';
import ScheduledMeetings from './pages/ScheduledMeetings/ScheduledMeetings';
import ProfileEdit from './pages/ProfileEdit/ProfileEdit';
import CallStatus from './pages/CallStatus/CallStatus';
import SubscriptionType from './pages/SubscriptionType/SubscriptionType';
import AuthPage from './pages/AuthPage/AuthPage';
import MarketerTeams from './pages/MarketerTeams/MarketerTeams';
import MarketerTeam from './pages/MarketerTeam/MarketerTeam';
import MartExecTeam from './pages/MartExecTeam/MartExecTeam';
import Executive from './pages/Executives/Executive';

import TeamsView from './pages/TeamsView/TeamsView';
import AssignOfficeToTeam from './pages/AssignOfficeToTeam/AssignOfficeToTeam';
import SubscriptionOverview from './pages/SubscriptionOverview/SubscriptionOverview';
import OperationsOverview from './pages/OperationsOverview/OperationsOverview';
import PopTarget from './pages/PopTarget/PopTarget';
import TargetsOverview from './pages/TargetsOverview/TargetsOverview';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './theme';
import OfficeStatus from './pages/OfficeStatus/OfficeStatus';
import Availability from './pages/Availability/Availability';
import { MantineProvider } from '@mantine/core';
import CompensationReport from './pages/CompensationReport/CompensationReport';
import OfficeDetails from './pages/OfficeDetails/OfficeDetails';
import MyOffices from './pages/MyOffices/MyOffices';
import TeamProgress from './pages/TeamProgress/TeamProgress';
import MyLinks from './pages/MyLinks/MyLinks';
import ReportComps from './pages/ReportComps/ReportComps';
function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar closeOnClick={true} />

      <MantineProvider
        withGlobalStyles
        withNormalizeCSS
        theme={{
          fontFamily: 'Roboto,san-serif',
          fontSizes: { xs: '16px', lg: '16px', md: '16px', sm: '16px' },
        }}>
        <ThemeProvider theme={theme}>
          <Router>
            <Routes>
              {/* These routes do not require authentication */}
              <Route element={<PublicRoute />}>
                <Route path="/" element={<AuthPage />} />

                <Route path="/reset_password">
                  <Route path="" element={<ResetPassword />} />
                  <Route path=":id/:token" element={<ResetPassword />} />
                </Route>
              </Route>
              <Route path="/profile">
                <Route path="/profile/edit" index element={<ProfileEdit />} />
              </Route>

              {/* Routes that require authorization go here */}
              {/* add route to PrivateRoutes.js in the marketer, snr_marketer or operations array so user can access */}
              <Route element={<PrivateRoutes />}>
                {/* Routes for senior marketing Executives */}
                <>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="workload" element={<Workload />} />
                  <Route path="scheduled-meetings" element={<ScheduledMeetings />} />
                  <Route path="/assign-office" element={<AssignOffice />} />
                  <Route path="/office-status">
                    <Route path="" element={<OfficeStatus />} />
                    <Route path=":id" element={<OfficeDetails />} />
                  </Route>
                  <Route path="agent-office">
                    <Route path="" element={<AddNewOffice />} />
                    <Route path=":loc">
                      <Route path="" element={<OfficeLocations />} />
                      <Route path=":off" element={<OfficeAgents />} />
                    </Route>
                  </Route>
                  <Route path="add-marketing-exec">
                    <Route path="" element={<ViewMarketingExec />} />
                    <Route path="add" element={<AddMarketingExec />} />
                  </Route>
                  <Route path="do-not-call-list" element={<DoNotCallList />} />
                  <Route path="/call-status" element={<CallStatus />}>
                    <Route path=":status" element={<DoNotCallList />} />
                  </Route>
                  <Route path="sub">
                    <Route path="/sub/:type" element={<SubscriptionType />} />
                  </Route>
                  <Route path="teams-progress" element={<TeamProgress />} />
                </>

                {/* Routes for marketing Executives  */}
                <>
                  <Route path="/marketing-exec-dashboard" element={<MarketingExecDashboard />} />
                  <Route path="my-tasks" element={<MyTasks />}>
                    <Route path="list">
                      {/* <Route path="" element={<MyTasksList />} /> */}
                      <Route path="" element={<MyOffices />} />
                    </Route>
                    <Route path="board" element={<MyTasksBoard />} />
                    <Route path="calendar" element={<MyTasksCalendar />} />
                  </Route>
                  <Route path="/office/:id" element={<MyTasksBoard />} />
                  <Route path="/compensation" element={<Compensation />} />
                  <Route path="/marketing-materials" element={<Errorpage />} />
                  <Route path="/availability" element={<Availability />} />
                  <Route path="/my-links" element={<MyLinks />} />
                </>
                {/* Routes for operations team */}
                <>
                  <Route path="/operations-overview" element={<OperationsOverview />} />
                  <Route path="sales-target">
                    <Route path="" element={<TargetsOverview />} />
                    <Route path="set/*" element={<PopTarget />} />
                  </Route>
                  <Route path="agent-offices">
                    <Route path="" element={<AddNewOffice />} />
                    <Route path=":companyId">
                      <Route path="" element={<OfficeLocations />} />
                    </Route>
                  </Route>
                  <Route path="/submitted-offices">
                    <Route path="" element={<OfficeStatus />} />
                    <Route path=":id" element={<OfficeDetails />} />
                  </Route>

                  <Route path="/">
                    <Route path="executive/:type">
                      <Route path="" element={<Executive />} />
                      <Route path="add" element={<AddMarketingExec />} />
                    </Route>
                  </Route>

                  <Route path="mart-exec-teams">
                    <Route path="" element={<MartExecTeam />} />
                    <Route path=":teamId" element={<MarketerTeam />} />
                  </Route>

                  <Route path="assign-mk-to-team">
                    <Route path="" element={<MarketerTeams />} />
                    <Route path=":teamId" element={<MarketerTeam />} />
                  </Route>
                  <Route path="assign-team-to-snr-marketer">
                    <Route path="" element={<TeamsView />} />
                    <Route path=":teamId" element={<MarketerTeam />} />
                  </Route>
                  <Route path="assign-office-to-team">
                    <Route path="" element={<AddNewOffice />} />
                    <Route path=":id" element={<AssignOfficeToTeam />} />
                  </Route>
                  <Route path="subscription-overview/:type" element={<SubscriptionOverview />} />
                  <Route path="compensation-report" element={<CompensationReport />} />
                  <Route path="report-comps" element={<ReportComps />} />
                </>
              </Route>

              <Route path="*" element={<Errorpage />} />
            </Routes>
          </Router>
        </ThemeProvider>
      </MantineProvider>
    </>
  );
}

export default App;
